import { cx, css } from '@emotion/css';
import styles from './HeaderFixed.styles';
import { useScroll, useMotionValueEvent } from 'framer-motion';
import { useEffect, useState } from 'react';

interface HeaderFixedProps {
  children: React.ReactNode;
  className?: string;
  animatedShadow?: boolean;
  ariaLabel?: string;
}

export const HeaderFixed: React.FC<HeaderFixedProps> = ({
  children,
  className,
  animatedShadow = false,
  ariaLabel,
}) => {
  const { scrollY } = useScroll();
  const [hasShadow, setHasShadow] = useState(false);

  useEffect(() => {
    if (animatedShadow) {
      setHasShadow(scrollY.get() > 0);
    }
  }, [scrollY, animatedShadow]);

  useMotionValueEvent(scrollY, 'change', latest => {
    if (!animatedShadow) return;
    const shouldShowShadow = latest > 0;
    if (shouldShowShadow !== hasShadow) {
      setHasShadow(shouldShowShadow);
    }
  });

  return (
    <header
      className={cx(styles.container, className, animatedShadow && hasShadow && styles.shadow)}
      id="headerFixed"
      data-testid="headerFixed"
      aria-label={ariaLabel}
    >
      {children}
    </header>
  );
};
